import React from "react";
import { useRefinementList } from "react-instantsearch";

export function VirtualRefinementList(props) {
  useRefinementList(props);

  return null;
}
